@if (typeScorePrevention() == 'default' || typeScorePrevention() == 'greylist') {
<div class="d-flex flex-column defgrey canevas">
  <div class="d-flex flex-row head justify-content-center align-items-center">
    <h3>{{'preventional-score' | translate}}</h3>
    <div class="gscore d-flex flex-row">
      <h4 class="defaut">{{'attestations-score-global' | translate}}:</h4>
      <div class="card border-0">
        <div class="card-img-overlay d-flex justify-content-center align-items-center p-0">
          <div class="card border-0">
            <mat-progress-spinner [color]="'primary'" [mode]="'determinate'"
              [value]="formatScore(scoreCourant?.scorePrevention)" class="card-img">
            </mat-progress-spinner>
            <div class="card-img-overlay d-flex justify-content-center align-items-center p-0">
              <h3 class="letter-spacing text-muted text-center">
                {{formatScore(scoreCourant?.scorePrevention)}}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="totalRules d-flex flex-row justify-content-end align-items-center">
      <h4 class="defaut">{{'attestation-preventional-score-rules-check' | translate}}:</h4>
      <h4 class='id'>{{scoreCourant?.totalRulechecks}}</h4>
    </div>
    <div class="d-flex flex-row justify-content-center align-items-center legend">
      <div class="ok-state d-flex flex-wrap align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="10" fill="#46BEAA" />
        </svg>
        <h5>{{'attestations-probe-status-ok' | translate}}</h5>
      </div>
      <div class="warning-state d-flex flex-wrap align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="10" fill="#FFEB78" />
        </svg>
        <h5>{{'attestations-probe-status-warning' | translate}}</h5>
      </div>
      <div class="fatal-state d-flex flex-wrap align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <circle cx="10" cy="10" r="10" fill="#DB0015" />
        </svg>
        <h5>{{'attestations-probe-status-fatal' | translate}}</h5>
      </div>
    </div>
  </div>
  <hr class="accordeon-hr v2">
  @if (typeScorePrevention() == 'greylist') {
  <div class="greylistpart d-flex flex-column">
    <div class="d-flex flex-row justify-content-between align-items-center hgeylist">
      <h4>{{'attestation-preventional-score-greylisted' | translate}}</h4>
      <h4>{{'attestation-preventional-score-total-total-preventional-weigh' | translate}}:
        <b>{{scoreCourant?.globalWeight}}</b>
      </h4>
    </div>
    <div class="greylist d-flex flex-wrap justify-content-center align-items-center">
      @for (gr of getGreylist(); track gr) {
      <div class="d-flex flex-column justify-content-center">
        <img class="align-self-center" src="assets/icons/greylist.svg" alt="">
        <h5 class="text-capitalize">{{gr.name}}</h5>
        <h6>{{'attestation-preventional-score-impact-weigth' | translate}}: {{gr.weight}}</h6>
      </div>
      }
    </div>
  </div>
  <hr class="accordeon-hr v2">
  }
  <div class="d-flex flex-row justify-content-center align-items-center">
    <h5 class="invalidtotal">Invalid | Total</h5>
    <div class="liste d-flex flex-wrap justify-content-center">
      @for (k of getAllScoreFamily(); track k) {
      <div class="d-flex flex-column justify-content-center">
        @if(isAdmin()){
        <div class="d-flex btn-family align-self-center">
          @if (formatScoreFamily(k[0]) != 'black&White') {
          <img id="probe-{{k[0].toLowerCase()}}" type="button" (click)="emitFamily(formatScoreFamily(k[0]))"
            class="{{statutScorePrevention(k[1])}}"
            src="assets/icons/probesFamilies/{{formatScoreFamily(k[0].toLowerCase())}}.svg">
          }
          @if (formatScoreFamily(k[0]) == 'black&White') {
          <img id="probe-{{k[0].toLowerCase()}}" type="button" (click)="emitFamily(formatScoreFamily(k[0]))"
            class="{{statutScorePrevention(k[1])}}" src="assets/icons/probesFamilies/{{formatScoreFamily(k[0])}}.png">
          }
        </div>
        }@else {
          <div class="d-flex align-self-center">
            @if (formatScoreFamily(k[0]) != 'black&White') {
            <img id="probe-{{k[0].toLowerCase()}}"
              class="{{statutScorePrevention(k[1])}}"
              src="assets/icons/probesFamilies/{{formatScoreFamily(k[0].toLowerCase())}}.svg">
            }
            @if (formatScoreFamily(k[0]) == 'black&White') {
            <img id="probe-{{k[0].toLowerCase()}}"
              class="{{statutScorePrevention(k[1])}}" src="assets/icons/probesFamilies/{{formatScoreFamily(k[0])}}.png">
            }
          </div>
        }

        <h5 class="text-capitalize">{{formatScoreFamily(k[0])}}:
          @if (k[1]) {
          <b>{{k[1]}}</b>
          } @else {
          <b class="na">NA</b>
          }
        </h5>
        <h6>{{getInvalidPreventionalScore(formatScoreFamily(k[0]))[1]}} |
          {{getTotalPreventionalScore(formatScoreFamily(k[0]))[1]}}</h6>
      </div>
      }
    </div>
  </div>
  <hr class="accordeon-hr v2">
  <h3 class="triggered-rules">{{'attestation-preventional-score-triggered-rules' | translate}}:</h3>
  <div class="d-flex flex-wrap trules">
    @for (rules of scoreCourant?.rulesTriggered; track rules) {
    <h4 class="trg-rl">{{rules}}</h4>
    }
  </div>
  <hr class="accordeon-hr v2">
  <div class="d-flex flex-row align-items-center justify-content-between ruletravel">
    @if (scoreCourant?.ruleset) {
    <h4 class="value">{{'attestations-score-rule-set' | translate}} <b>{{scoreCourant?.ruleset}}</b></h4>
    }
    @if (scoreCourant?.travelVelocity) {
    <h4 class="value">{{'attestations-score-travel-velocity' | translate}} <b>{{scoreCourant?.travelVelocity}}</b></h4>
    }
  </div>
</div>
} @else {
@if (typeScorePrevention() == 'whitelist') {
<div class="d-flex flex-column canevas">
  <hr class="whitelist d-flex align-self-center">
  <h4 class="text-center">{{'attestation-preventional-score-whitelisted' | translate}}</h4>
  <hr class="whitelist d-flex align-self-center">
</div>
} @else {
@if (typeScorePrevention() == 'blacklist') {
<div class="d-flex flex-column canevas">
  <hr class="blacklist d-flex align-self-center">
  <h4 class="text-center">{{'attestation-preventional-score-blacklisted' | translate}}</h4>
  <hr class="blacklist d-flex align-self-center">
</div>
}
}
}